import { Link, Navigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { MaskLines, Eyebrow } from "@/components/site/Reveal";
import EnrolmentForm from "@/components/enrol/EnrolmentForm";
import { FORMS, JOIN } from "@/data/content";

const Tabs = ({ type }) => (
  <div className="inline-flex flex-wrap gap-1 rounded-full bg-white/10 p-1 backdrop-blur border border-white/15" data-testid="enrolment-tabs">
    {JOIN.map((j) => (
      <Link key={j.type} to={`/join/${j.type}`} data-testid={`enrolment-tab-${j.type}`}
        className={`relative px-4 sm:px-5 py-2.5 rounded-full text-sm font-semibold transition-colors ${type === j.type ? "text-[#14083E]" : "text-white/80 hover:text-white"}`}>
        {type === j.type && <motion.span layoutId="tab-pill" className="absolute inset-0 rounded-full bg-white" transition={{ type: "spring", stiffness: 380, damping: 32 }} />}
        <span className="relative">{j.label}</span>
      </Link>
    ))}
  </div>
);

export default function Enrolment() {
  const { type } = useParams();
  const cfg = FORMS[type];
  if (!cfg) return <Navigate to="/join/franchise" replace />;
  const img = JOIN.find((j) => j.type === type).img;
  return (
    <main data-testid={`enrolment-page-${type}`}>
      <Navbar />
      <section className="relative bg-[#0B0424] text-white pt-32 sm:pt-40 pb-40 overflow-hidden grain">
        <div aria-hidden className="absolute -top-40 -right-20 h-[520px] w-[520px] rounded-full bg-[#E5157A]/35 blur-[140px]" />
        <img src={img} alt="" aria-hidden className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-20 hidden md:block [mask-image:linear-gradient(to_left,black,transparent)]" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
          <Tabs type={type} />
          <div className="mt-10"><Eyebrow dark>Join us · {cfg.kicker}</Eyebrow></div>
          <h1 key={type} className="mt-5 font-display font-extrabold tracking-[-0.035em] leading-[0.95] text-5xl sm:text-6xl lg:text-7xl" data-testid="enrolment-title">
            <MaskLines lines={[cfg.title.split(" ")[0], { text: "Enrolment.", className: "text-brand-gradient" }]} />
          </h1>
          <p className="mt-6 max-w-xl text-white/80 text-base sm:text-lg leading-relaxed">{cfg.intro}</p>
        </div>
      </section>
      <section className="relative bg-[#FAFAFC] pb-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-8 -mt-24 relative">
          <motion.div key={type} initial={{ opacity: 0.001, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-[32px] bg-white p-6 sm:p-10 shadow-[0_40px_80px_-30px_rgba(20,8,62,0.35)] border border-[#14083E]/5">
            <EnrolmentForm key={type} type={type} cfg={cfg} />
          </motion.div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
